/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Status_AppliedInputs */

const en_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied`)
};

const de_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beworben`)
};

const fr_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postulé`)
};

const es_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postulado`)
};

const it_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidata`)
};

const nl_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesolliciteerd`)
};

const pl_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysłano`)
};

const fi_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haettu`)
};

const da_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgt`)
};

const sv_applications_status_applied = /** @type {(inputs: Applications_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökt`)
};

/**
* | output |
* | --- |
* | "Applied" |
*
* @param {Applications_Status_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_status_applied = /** @type {((inputs?: Applications_Status_AppliedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Status_AppliedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_status_applied(inputs)
	if (locale === "fr") return fr_applications_status_applied(inputs)
	if (locale === "es") return es_applications_status_applied(inputs)
	if (locale === "it") return it_applications_status_applied(inputs)
	if (locale === "nl") return nl_applications_status_applied(inputs)
	if (locale === "pl") return pl_applications_status_applied(inputs)
	if (locale === "fi") return fi_applications_status_applied(inputs)
	if (locale === "da") return da_applications_status_applied(inputs)
	if (locale === "sv") return sv_applications_status_applied(inputs)
	return en_applications_status_applied(inputs)
});